import React from 'react';
import { Form, FormGroup, Col, Row } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner';
import * as Convert from '../util/unitConversion';


class OrderStatusInfo extends React.Component {

    render() {
        const data = this.props.orderStatus===undefined ? {} : this.props.orderStatus;

        if (this.props.orderStatus===undefined)
        {
            return (<div className="height180"><LoadingSpinner isLoading={true} /> </div>);
        }
        else
        {
            return (
                <Col sm={12}>
                    <Form horizontal autoComplete="off" onSubmit={evt => { evt.preventDefault(); }} style={{"width" : "1800px"}}>
                        <FormGroup>
                            <Row>
                                {/* <Col sm={1}>Estimated prod. date:</Col>
                                <Col xs={1}>{data.EstimatedProdDate}</Col> */}
                                {data.CsmStatus && 
                                    <React.Fragment>
                                        <Col sm={1}>CSM Status:</Col>
                                        <Col xs={2}>{data.CsmStatus}</Col>
                                    </React.Fragment>
                                }
                            </Row>
                            <br />
                            <Row className="row-eq-height">
                                <Col xs={1}>
                                    <Row> <Col xs={8}>&nbsp;</Col></Row>
                                    <Row> <Col xs={10}><Convert.TextTo value_metric={"Weight (kg)"} value_imperial={"Weight (lb)"}/></Col></Row>
                                    <Row> <Col xs={10}>Rolls/Sheet (pcs)</Col></Row>
                                </Col>

                                <Col xs={1} className="left-border">
                                    <Row> <Col xs={1}>Ordered</Col></Row>
                                    <Row> <Col xs={1}>{data.OrderedWeight_UC}</Col></Row>
                                    <Row> <Col xs={1}>{data.OrderedQuantity}</Col></Row>
                                </Col>
                                
                                <Col xs={1} className="left-border">
                                    <Row> <Col xs={1}>Planned</Col></Row>
                                    <Row> <Col xs={1}>{data.PlannedWeight_UC}</Col></Row>
                                    <Row> <Col xs={1}>{data.PlannedQuantity}</Col></Row>
                                </Col>
                                
                                <Col xs={1} className="left-border">
                                    <Row> <Col xs={1}>Produced</Col></Row>
                                    <Row> <Col xs={1}>{data.ProducingWeight_UC}</Col></Row>
                                    <Row> <Col xs={1}>{data.ProducingQuantity}</Col></Row>
                                </Col>
                                
                                <Col xs={1} className="left-border">
                                    <Row> <Col xs={1}>Stock</Col></Row>
                                    <Row> <Col xs={1}>{data.StockWeight_UC}</Col></Row>
                                    <Row> <Col xs={1}>{data.StockQuantity}</Col></Row>
                                </Col>

                                <Col xs={1} className="left-border">
                                    <Row> <Col xs={1}>Shipped</Col></Row>
                                    <Row> <Col xs={1}>{data.ShippedWeight_UC}</Col></Row>
                                    <Row> <Col xs={1}>{data.ShippedQuantity}</Col></Row>
                                </Col>

                                <Col xs={4} className="left-border">
                                    <Row> <Col xs={4}>GTR</Col></Row>
                                    <Row> <Col xs={4}>{data.GTRWeight_UC}</Col></Row>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                </Col>
            )
        }
    }
}

export default OrderStatusInfo;